import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TitleUI } from '../../../../../components/UI/LabelTitleUI'
import BackButton from '../../../../../components/UI/BackButton';
import { ENUMS } from '../../../../../utils/constants';
import LinePickingService from '../../../../../services/LinePickingService';
import { translate } from "../../../../../utils/util";

const BoardKanban = (props) => {
    const [cards, setCards] = useState([]);
    const [refreshed, setRefreshed] = useState(0);

    useEffect(() => {
        props.getKanban((data) => {
            setCards(data);
        })
        // eslint-disable-next-line
    }, [refreshed]);

    const getColorsAlerts = (typeId) => {
        const alerts = Object.values(ENUMS.eTypeAlert);
        const item = alerts.find(f => f.typeAlertId === typeId);
        return item.color;
    }

    return (
        <div className="row">
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-developer-board" label={translate('line-picking:linepicking.kanban')} />
                </div>
            </div>
            <div className="title" style={{ float: 'right', margin: '5px' }}>
                <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => setRefreshed(refreshed + 1)}>{'refresh'}</i>
            </div>
            <div style={{ padding: '5px', marginTop: '40px' }}>
                {cards.length > 0 &&
                    cards.map((card, index) => (
                        <div key={`col${card.route.code}-${index}`} className="col s6 m4">
                            <div key={`div-${index}`} className="z-depth-2 box-button " style={{ minHeight: '120px', borderBottomStyle: 'solid', borderBottomColor: getColorsAlerts(card.typeAlert), borderBottomWidth: '4px' }}>
                                <Link key={`link-${card.route.code}-${index}`} to={{ pathname: 'kanban/list', state: { data: card.orders } }}>
                                    <div key={`name-${index}`} style={{ fontSize: '1.5rem', textAlign: 'center', textTransform: 'uppercase' }}>{translate('line-picking:linepicking.route')} : {card.route.code}</div>
                                    <div key={`qtd-${card.totalItems}-${index}`} style={{ fontSize: '1.4rem', textAlign: 'center', color: getColorsAlerts(card.typeAlert) }}>{translate('expedition:picking.orders')}: {card.totalItems}</div>
                                    <div key={`assignedItems-${card.assignedItems}-${index}`} style={{ fontSize: '1.4rem', textAlign: 'center', color: getColorsAlerts(card.typeAlert) }}>
                                        <div className="divider" />{translate('general.attributed')}: {card.assignedItems}</div>
                                </Link>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getKanban: (callback) => {
            dispatch(LinePickingService.getKanban(callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BoardKanban)));
